import _isEmpty from 'lodash/isEmpty'
import _isObject from 'lodash/isObject'
import _isString from 'lodash/isString'

export function extractFirstUrl(text: string | Record<string, Any> | null): string {
  if (!text || text === null) {
    return ''
  }

  let url = ''
  if (_isObject(text)) {
    url = text.url as string
  }

  if (!url) {
    try {
      const parsedValue = JSON.parse(text as string)
      if (parsedValue?.url) {
        url = parsedValue.url
      }
    } catch {
      // Not JSON, fall through to regex parsing
    }
  }

  if (!url) {
    const urlRegex = /(https?:\/\/[^\s]+)/
    const match = text.match(urlRegex)
    if (match) {
      url = match[0]
    }
  }

  return url
}

export function removeQueryParams(url: string): string {
  if (!_isString(url) || _isEmpty(url)) {
    return url
  }

  const questionMarkIndex = url.indexOf('?')
  return questionMarkIndex !== -1 ? url.substring(0, questionMarkIndex) : url
}

export function joinUrls(...parts: string[]): string {
  if (_isEmpty(parts) || parts.length === 0) {
    return ''
  }

  const joined = parts
    .filter(Boolean)
    .map((part, index) => {
      if (index === 0) {
        // Remove trailing slashes only for the first part
        return part.replace(/\/+$/, '')
      }
      // Remove leading and trailing slashes for middle parts
      return part.replace(/^\/+|\/+$/g, '')
    })
    .join('/')

  return joined ? `${joined.replace(/\/+$/, '')}/` : ''
}

export function appendQueryParams(
  baseUrl: string,
  params: Record<string, string | number | boolean | undefined | null>
): string {
  const url = new URL(baseUrl)

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.append(key, String(value))
    }
  })

  return url.toString()
}

export function ensureTrailingSlash(url: string): string {
  if (!url) {
    return url
  }
  return url.endsWith('/') ? url : `${url}/`
}

export function stripQueryParamFromUrl(paramName: string): void {
  if (typeof window === 'undefined') {
    return
  }

  const params = new URLSearchParams(window.location.search)
  if (!params.has(paramName)) {
    return
  }

  params.delete(paramName)
  const search = params.toString()
  const { pathname, hash } = window.location
  const url = search ? `${pathname}?${search}${hash}` : `${pathname}${hash}`
  window.history.replaceState(window.history.state, '', url)
}
